import React from 'react';
import { IoMdCheckmark } from './react-icons/main/index.esm';

const Checkbox = ({ active, showOnHover, onClick, title }) => {
  return (
    <div className={`comp-checkbox ${active ? 'active' : ''} ${showOnHover ? 'show-on-hover' : ''}`} onClick={onClick} data-title={title}>
      {(active || showOnHover) && <IoMdCheckmark />}
    </div>
  );
};

export default Checkbox;
